<template>
  <media-slider-chapters class="relative flex h-full w-full items-center rounded-[1px]">
    <template>
      <!-- Chapter -->
      <div class="relative last-child:mr-0 z-0 flex h-full w-full items-center chapter mr-0.5 rounded-[1px]">
        <!-- Track -->
        <div class="relative z-10 w-full rounded-sm bg-white/20 ring-media-focus h-[5px] group-data-[focus]:ring-[3px]">
          <!-- Progress -->
          <div class="absolute z-0 h-full w-[var(--chapter-progress)] rounded-sm bg-white/20 will-change-[width]"/>
          <!-- Fill -->
          <div class="bg-[#dc2626] z-20 absolute h-full w-[var(--chapter-fill)] rounded-sm will-change-[width]"/>
        </div>
      </div>
    </template>
  </media-slider-chapters>
</template>

<style scoped>
.chapter {
  contain: layout style;
}

.track {
  contain: strict;
}
</style>
